import React, { lazy } from 'react';
import { BrowserRouter as Router, Redirect, Route, useLocation } from 'react-router-dom';
import { Loading } from '@guryou/html-components';
import Header from 'components/navigation/Header';
import { SidebarAdminProvider } from 'components/navigation/SidebarAdminContext';
import { getManagementLandingPath } from 'utils/landingPage';

const Admin = lazy(() => import('./admin'));
const Business = lazy(() => import('./business'));
const Providers = lazy(() => import('./providers'));

// Fit Library (formerly PreviousStudio) and Coaching (formerly TRAINING, nav-labeled
// "Coached Board" at the time) used to ALSO be lazy-loaded and routed here as bare,
// provider-less paths (/fit-library, /coached-board) — an orphaned duplicate of their
// real mount under /providers/:id/fit-library and /providers/:id/coaching. Both
// modules are provider-scoped features (every consumer lives inside
// modules/providers/), so they've moved to live there physically too; this second,
// provider-less mount was removed with them.

const ConditionalHeader = () => {
  const location = useLocation();
  const isAdmin = location.pathname.includes('/admin');
  const isProviders = location.pathname.includes('/providers/');
  const isBusiness = location.pathname.includes('/management');

  if (isAdmin || isProviders || isBusiness) {
    return null;
  }

  return <Header />;
};

const Modules = () => {
  return (
    <>
      <Router>
        <Loading />
        <SidebarAdminProvider>
          <ConditionalHeader />
          <Route path="/admin" component={Admin} />
          <Route path="/management" component={Business} />
          <Route path="/providers/:providerId" component={Providers} />
          <Route exact path="/" render={() => <Redirect to={getManagementLandingPath()} />} />
        </SidebarAdminProvider>
      </Router>
    </>
  );
};
export default Modules;
